/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingOneAlgorithmSimulationParams = {
    listingType?: ListingOneAlgorithmSimulationParams.listingType;
    listingId?: string;
    accommodationId?: string;
    reviewsVolume?: number | null;
    accommodationMultiplier?: number | null;
    provision?: number | null;
    reservationType?: number | null;
    roomFit?: number | null;
    activeReservation?: number | null;
    conversion?: number | null;
    availabilityMultiplier?: number | null;
    aovSegmentation?: number | null;
    constListingMultiplier?: number | null;
    readonly overrides?: boolean;
};
export namespace ListingOneAlgorithmSimulationParams {
    export enum listingType {
        COUNTRY = 'country',
        CITY = 'city',
        REGION = 'region',
        LEGACY_COUNTRY = 'legacy_country',
        LEGACY_VOIDESHIP = 'legacy_voideship',
        LEGACY_CITY = 'legacy_city',
        LEGACY_REGION = 'legacy_region',
    }
}
